const app = require('./app')
const { timeAgo, formatTime } = require('./timeAgo.js')

export class Template {
    constructor(e) {
        if (this.init) this.init(e)
    }

    updateCastContent(element, data, template) {
        element.innerHTML = template.innerHTML.replace(/\{\$([a-zA-Z0-9_]+)\}/g, function (match, keyName) {
            if (keyName == 'lastSeen') {
                if (data.isLive) {
                    return 'Online'
                } else {
                    return timeAgo(data[keyName])
                }
            }
            if (keyName == 'timeAgo' && data.time) return timeAgo(data.time)
            if (keyName == 'location' && (!data.location.length || data.location == 'None')) {
                data.location = 'No location info'
                return 'No location info'
            }

            if (keyName == 'appImg') {
                if (data.appImg && data.appImg !== '') {
                    var str = data.appImg.trim().split(' ')
                    var imgBLock = document.createElement('div')
                    const defaultIcon = './android.robot.jpeg'
                    str.forEach((icon) => {
                        if (icon !== '') {
                            var imgCover = document.createElement('span')
                            imgCover.innerHTML = `<img src="${icon}" onerror="this.src='${defaultIcon}'">`
                            imgBLock.appendChild(imgCover)
                        }
                    })

                    return imgBLock.innerHTML
                } else {
                    data.appImg = ' '
                    return ' '
                }
            }

            if (keyName == 'remainingImg') {
                if (data.remainingImg && data.remainingImg > 0) {
                    return '+ ' + data.remainingImg + ' more'
                } else {
                    data.remainingImg = ' '
                    return ' '
                }
            }
            if (keyName == 'length' && data.length <= 0) {
                return "00:01"
            }
            else {
                if (keyName == 'length' && data.length) return formatTime(data.length)
            }
            return data[keyName] || match
        })
    }
    updateLocationContent(element, data) {
        var mapOptions = {
            center: [data['latitude'], data['longitude']],
            zoom: 15,
            zoomControl: false,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: 'bottomright',
            },
            gMapButtonControl: true,
            gMapButtonControlOptions: {
                position: 'topright',
            },
        }
        var map = new L.map(element, mapOptions)
        var layer = new L.TileLayer(`http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`)
        var marker = new L.Marker([data['latitude'], data['longitude']])
        window.map = map
        window.marker = marker
        marker.addTo(map)
        map.addLayer(layer)
    }
    updateCast(element, data, template, onClick) {
        const timelineElement = element.parentElement
        this.updateCastContent(timelineElement, data, template)

        element = timelineElement.firstElementChild

        element.className = 'cast-item'
        // Attach event listener based on the derived class's method
        if (typeof this.setElementEventListener === 'function') {
            this.setElementEventListener(element, data)
        }

        if (onClick) {
            element.addEventListener('click', (e) => {
                onClick(data)
            })
        }
        const srcAttrs = element.querySelectorAll('[data-src]')
        for (let attr of srcAttrs) {
            attr.removeAttribute('onload')
            attr.setAttribute('src', attr.getAttribute('data-src'))
            attr.removeAttribute('data-src')
        }

        return element
    }

    inject(className, data, target, template, prepend = false, onClick) {
        let element = document.createElement('div')
        element.setAttribute('class', className)

        this.updateCastContent(element, data, template)
        if (prepend) {
            target.insertBefore(element, target.firstChild)
        } else {
            target.appendChild(element)
        }
        if (data.latitude || data.longitude) {
            //Attention, to change location blur amount, see "sb-bl" in css
            if (!element.parentElement.classList.contains('sb-bl') || (element.parentElement.classList.contains('sb-bl') && [...element.parentElement.childNodes].indexOf(element) <= 3)) {
                this.locationElemClick(element, data)
                if (data.location_name === '') {
                    element.querySelector('.location-name').innerHTML = `lat: ${data.latitude}, long: ${data.longitude}`
                }
            } else if (element.parentElement.classList.contains('sb-bl') && [...element.parentElement.childNodes].indexOf(element) > 3) {
                let t = element.querySelector('.location-name').innerHTML
                let lt = element.querySelector('.location-time').innerHTML
                let r = 'GeoLocation'
                let rslt = ''
                let lrslt = ''
                for (var i = 0; i < Math.floor(t.length / r.length); i++) {
                    rslt += r
                }
                for (var i = 0; i < Math.floor(lt.length / r.length); i++) {
                    lrslt += r
                }
                element.querySelector('.location-name').style.maxWidth = '300px'
                element.querySelector('.location-name').style.overflow = 'hidden'
                element.querySelector('.location-name').innerHTML = rslt
                element.querySelector('.location-time').innerHTML = lrslt
            }
            if (!document.getElementById('map')) {
                let locationMap = document.createElement('div')
                locationMap.setAttribute('id', 'map')
                locationMap.style.height = '128px'
                document.getElementById('location-holder').prepend(locationMap)
                this.updateLocationContent(locationMap, data)
            }
        }
        // Attach event listener based on the derived class's method
        if (typeof this.setElementEventListener === 'function') {
            this.setElementEventListener(element, data)
        }
        if (onClick) {
            element.addEventListener('click', (e) => {
                let pNode = e.currentTarget.parentNode
                if (pNode && pNode.id && pNode.id == 'cast') {
                    if (e.target.parentNode.dataset && e.target.parentNode.dataset.castId) {
                        let clkBtnStr = '#cast [data-cast-id="' + e.target.parentNode.dataset.castId + '"] img'
                        if (history.state.page && history.state.page == 3) {
                            console.log('going to replace state 3', history.state)
                            history.replaceState({ page: 3, action: 'click', target: clkBtnStr }, 'Cast', '#/cast/' + e.target.parentNode.dataset.castId)
                            console.log('after replace state 3', history.state)
                        } else {
                            console.log('going to push state 3', history.state)
                            history.pushState({ page: 3, action: 'click', target: clkBtnStr }, 'Cast', '#/cast/' + e.target.parentNode.dataset.castId)
                            console.log('after push state 3', history.state)
                        }
                    }
                    onClick(data)
                }
            })
        }

        const srcAttrs = element.querySelectorAll('[data-src]')
        for (let attr of srcAttrs) {
            attr.setAttribute('src', attr.getAttribute('data-src'))
            attr.removeAttribute('data-src')
        }
        this.count += 1
        return element
    }
    locationElemClick(element, data) {
        element.addEventListener('click', (e) => {
            window.map.panTo([data.latitude, data.longitude])
            window.marker._latlng = { lat: data.latitude, lng: data.longitude }
            window.marker.update()

            let l = element.parentNode.querySelector('.icon-location--selected')
            if (l) {
                l.classList.remove('icon-location--selected')
            }
            element.querySelector('.icon-location').classList.add('icon-location--selected')
        })
    }
    injectAllData(data, target, template, className, onClick) {
        for (let item of data) {
            this.inject(className, item, target, template, false, onClick)
        }

        if (this.loadingCircle) this.loadingCircle.hide()
    }

    injectHeadData(headDataStack, target, template, className, onClick) {
        while (headDataStack.length) {
            let item = headDataStack.pop()
            this.inject(className, item, target, template, true, onClick)
        }
    }

    injectTailData(tailData, target, template, className, onClick) {
        for (let item of tailData) {
            this.inject(className, item, target, template, false, onClick)
        }
    }

    isTimelineEmpty(target) {
        return !target.firstElementChild
    }

    getTimelineBounds(target) {
        const firstChild = target.querySelector('.timeline-item:first-child div')
        let lastChild = target.querySelectorAll('.timeline-item > div')
        lastChild = lastChild[lastChild.length - 1]

        return {
            firstTimeInDOM: parseInt(firstChild.getAttribute('data-time'), 10),
            lastTimeInDOM: parseInt(lastChild.getAttribute('data-time'), 10),
        }
    }

    fetchMore() {
        app.data.get({ type: this.dataType, identifier: this.device_id }, (data) => {
            if (!data || data.length === 0) return

            const items = data.length
            app.webSocket.sendMessage({
                type: this.wsName,
                device_id: this.device_id,
                from: items,
                to: items + this.itemsPerFetch,
            })
        })
    }

    update(views, data) {
        if (this.onUpdate) this.onUpdate(data)

        const target = this.uiTarget || document.getElementById(this.dataType)
        const template = document.getElementById(this.dataType + '_items')

        for (let castData of data.data) {
            if (data.data.length === 1) {
                const elements = target.querySelectorAll("[data-cast-id='" + castData.id + "']")
                for (let element of elements) {
                    this.updateCast(element, castData, template)
                }
            }
        }

        app.data.get(
            {
                type: this.dataType,
                identifier: this.device_id,
                limit: this.dataLimit || -1,
            },
            (data) => {
                if (!data || data.length === 0) return

                if (this.isTimelineEmpty(target)) {
                    this.injectAllData(data, target, template, 'timeline-item', this.clickEvent)
                    return
                } else {
                    // for (let castData of data) {
                    //   const elements = target.querySelectorAll("[data-cast-id='" + castData.id + "']");
                    //   for (let element of elements) {
                    //     this.updateCast(element, castData, template);
                    //   }
                    // }
                }

                const { firstTimeInDOM, lastTimeInDOM } = this.getTimelineBounds(target)

                //console.log('firstTimeInDOM', firstTimeInDOM, 'lastTimeInDOM', lastTimeInDOM)

                let headDataStack = []
                let tailData = []

                for (let cast of data) {
                    if (cast.time > firstTimeInDOM) {
                        headDataStack.push(cast)
                    } else if (cast.time < lastTimeInDOM) {
                        tailData.push(cast)
                    }
                }

                this.injectHeadData(headDataStack, target, template, 'timeline-item', this.clickEvent)
                this.injectTailData(tailData, target, template, 'timeline-item', this.clickEvent)
            }
        )
    }
}
